import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const { authData, role, storeId } = useSelector((state) => state.loginSlice);

  return authData ? (
    !storeId ? (
      <Navigate to="/selectstore" replace />
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to="/login" replace />
  );
};

export default PrivateRoute;
